/**
 * RotateDeviceHint
 *
 * Subtle, non-blocking nudge shown on phones when the device orientation doesn't match the
 * video's native aspect (e.g. a 16:9 video held in portrait). It never forces rotation or covers
 * the video — when the viewer rotates, the player refits to fill and the hint disappears.
 */

import React from 'react';
import { RotateCw } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface RotateDeviceHintProps {
  /** The orientation the video wants — used to phrase the hint. */
  target: 'portrait' | 'landscape';
  className?: string;
}

export const RotateDeviceHint: React.FC<RotateDeviceHintProps> = ({ target, className }) => {
  return (
    <div
      className={cn(
        'absolute inset-x-0 top-6 z-40 flex justify-center px-6 pointer-events-none',
        className
      )}
    >
      <div className="flex items-center gap-2 rounded-full bg-black/65 backdrop-blur-md border border-white/10 px-4 py-2 shadow-xl">
        <RotateCw className="h-4 w-4 text-white/90 animate-[spin_2.4s_ease-in-out_infinite]" />
        <span className="text-white/90 text-xs font-medium">
          Rotate your phone to {target} for the best view
        </span>
      </div>
    </div>
  );
};
